'use strict';

const {__, _x, _n, _nx} = wp.i18n;
import 'bootstrap/js/src/tab';
import $ from 'jquery';
import { EditorView, basicSetup } from 'codemirror';
import { css } from '@codemirror/lang-css';

class TWER_SETTINGS {

  $textarea = null;

  constructor() {

    this.$textarea = document.getElementById('js-twer-editor-textarea');
    this.$textarea.style.display = 'none';

    let editor = new EditorView({
      doc: this.$textarea.value,
      extensions: [basicSetup, css()],
      parent: document.querySelector('#js-twer-editor'),
    });

    if (this.$textarea.form) {
      this.$textarea.form.addEventListener('submit', () => {
        this.$textarea.value = editor.state.doc.toString();
      });
    }

  }
}

document.addEventListener('DOMContentLoaded', () => {
  new TWER_SETTINGS();
});
